import { BroadcastChannel } from 'broadcast-channel'

export const BROADCAST_CHANNEL = new BroadcastChannel('metis_channel')
